import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';


@Component({
  selector: 'app-tote-list',
  templateUrl: './tote-list.component.html',
  styleUrls: ['./tote-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ToteListComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();

  toteList: any;
  previousStatus = '';
  totalRecords: number;
  checkedListView = [];
  displayPopUP: string = 'N';
  barCodePopUP: string = 'N';
  commonPage: string = 'N';
  value: any;
  printTypes: string;
  printOptionError: string;
  noOfLabels: number = 1;
  noOfLabelsError: string;

  checkedList: any = [];
  masterSelected: boolean = false;
  myAngularxQrCode: string = null;
  barcodeValue: string = "";
  qrCodeValue: string = "";
  toteId: any;
  toDayDateAndTime = new Date().toLocaleString();

  constructor(private alertService: AlertService, private excelService: ExcelServiceService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals) {
    this.g.page = " Tote List";
    this.getTotesList();
  }

  commonPrintPopUp() {
    this.commonPage = 'Y';
  }


  /*   openBarcodePopup() {
      this.printOptionError ="";

      if (this.printTypes === null || this.printTypes === undefined || this.printTypes === '' || this.printTypes === 'undefined') {
        this.printOptionError = 'Please Select PrintOption';
      }
      if (this.printOptionError != "") {
        return false;
      }
      for (var i = 0; i < this.checkedList.length; i++) {
        this.checkedListView[i]['codeValue'] = 'PROD-' + this.checkedList[i];
      }
          this.barCodePopUP = 'Y';
      }

    openQRCodePopup() {
      this.printOptionError ="";

      if (this.printTypes === null || this.printTypes === undefined || this.printTypes === '' || this.printTypes === 'undefined') {
        this.printOptionError = 'Please Select PrintOption';
      }
      if (this.printOptionError != "") {
        return false;
      }
      for (var i = 0; i < this.checkedList.length; i++) {
        this.checkedListView[i]['codeValue'] = 'PROD-' + this.checkedList[i];
      }
        this.displayPopUP = 'Y';
    }
  getLabelSize(printTypes){
  if(printTypes==='24 labels with 63mm X 34mm'){
  return '24-labels';
  }else if(printTypes==='36 labels with 63mm X 34mm'){
  return '36-labels';
  }else if(printTypes==='40 labels with 63mm X 34mm'){
  return '40-labels';
  }
  }
  getWidth(printTypes){
  if(printTypes==='24 labels with 63mm X 34mm'){
  return '63mm !important';
  }else if(printTypes==='36 labels with 63mm X 34mm'){
  return '70mm !important';
  }else if(printTypes==='40 labels with 63mm X 34mm'){
  return '52.5mm !important';
  }
  }
  getHeight(printTypes){
  if(printTypes==='24 labels with 63mm X 34mm'){
  return '34mm !important';
  }else if(printTypes==='36 labels with 63mm X 34mm'){
  return '24.7mm !important';
  }else if(printTypes==='40 labels with 63mm X 34mm'){
  return '29.7mm !important';
  }
  } */
  checkUncheckAll() {
    for (var i = 0; i < this.toteList || [].length; i++) {
      this.toteList[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  selectShip(sl) {
    if (!sl.isSelected) { this.masterSelected = false }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    this.checkedListView = [];
    this.toteId = "";
    for (var i = 0; i < (this.toteList || []).length; i++) {
      if (this.toteList[i].isSelected) {
        this.checkedList.push(this.toteList[i]['toteId']);
        this.checkedListView.push(this.toteList[i]);
        this.toteId = this.toteList[i]['toteId'];
      }
    }
  }

  /*(printPopUp(p) {
    for (var i = 0; i < this.checkedList.length; i++) {
      this.checkedListView[i]['codeValue'] = 'PROD-' + this.checkedList[i];
    }
      this.displayPopUP = 'Y';
  } */

  closePopUp() {
    //this.checkedListView = [];
    this.displayPopUP = 'N';
  }

  commonPageClosePopUp() {
    this.commonPage = 'N';
    this.printTypes = "";
  }

  noOfLabelsBlur() {
    this.noOfLabelsError = "";
    if (!this.noOfLabels) {
      this.noOfLabelsError = 'Please Enter noOfLabels';
    }
  }

  /* openPopUPBarCode(b) {
     for (var i = 0; i < this.checkedList.length; i++) {
       this.checkedListView[i]['codeValue'] = 'PROD-' + this.checkedList[i];
     }
       this.barCodePopUP = 'Y';
   } */

  closePopUpBarCode() {
    //this.checkedListView = [];
    this.barCodePopUP = 'N';
  }

  clear() {
    this.getTotesList();
    this.commonPage = 'N';
    this.noOfLabels = 1;
    //this.checkedList = [];
    //this.checkedListView = [];
  }

  printQrAndBarCode() {

    this.printOptionError = "";
    this.noOfLabelsError = "";

    if (!this.printTypes) {
      this.printOptionError = 'Please Select PrintOption';
    }

    if (!this.noOfLabels) {
      this.noOfLabelsError = 'Please Enter noOfLabels';
    }
    if (this.printOptionError != "" || this.noOfLabelsError != "") {
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/getPdfUrlForTotes', {
      "labelSize": this.printTypes,
      "noOfLabels": this.noOfLabels,
      "toteId": this.toteId
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        //    console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'tote_' + this.toteId + '_label_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
        this.commonPage = 'N';
        this.getTotesList();
        this.checkedList = [];
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.getTotesList();
          this.checkedList = [];
          this.alertService.error('Error', err);
        });


  }
  /* print(){

    this.printOptionError ="";

    if (this.printTypes === null || this.printTypes === undefined || this.printTypes === '' || this.printTypes === 'undefined') {
      this.printOptionError = 'Please Select PrintOption';
    }
    if (this.printOptionError != "") {
      return false;
    }

    window.print();
  } */
  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.toteList, 'sample');
  }

  ngOnInit(): void {
    //  this.dtOptions = {
    //             pagingType: 'full_numbers',
    //             lengthMenu : [20, 50, 100, 200],
    //             pageLength: 20,
    //             order: [3,"desc"]

    //  };
  }

  getTotesList() {
    this.dtOptions = {
      //"ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      // serverSide: true,

      language: {
        searchPlaceholder: 'Search by Tote Name / Tote Type'
      },

      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.start = 0;
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getTotesList/1';

        let query: any = {
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.toteList = resp.totesList;
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            this.toteList.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }

    };

  }


  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  changeStatus(n) {
    this.g.loaderDisplay = "display";
    if (n.status == "ACTIVE") {
      n.status = "IN_ACTIVE";
    } else {
      n.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateToteStatus', {
      "id": n.toteId,
      "status": n.status
    }, { headers: header1 }).subscribe(data => {
      if (data['code'] == 200) {
        this.alertService.success('Tote', 'Status Updated Successfully');
        //    this.getTotesList();
      } else {
        this.alertService.error('Error', data['message']);
      }
      this.g.loaderDisplay = "";
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });

  }

}
